import get from 'lodash/get';
import {
  AppAdapter,
  UserInfoFields,
  RegistrationCompleteArgs
} from './AppAdapter';

export default class AndroidAdapter implements AppAdapter {
  android: Record<string, typeof Object> | null;

  constructor() {
    this.android = get(window, 'android', null);
  }

  setUserInfo(userInfo: Record<UserInfoFields, string>): void {
    try {
      if (this.android) {
        this.android.setUserInfo(JSON.stringify(userInfo));
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }

  registrationComplete(fundingInfo: RegistrationCompleteArgs): void {
    try {
      if (this.android) {
        this.android.registrationComplete(JSON.stringify(fundingInfo));
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }

  registrationFailed(error?: Error): void {
    try {
      if (this.android) {
        this.android.registrationFailed(error?.message || 'Failure');
      }
    } catch (err) {
      throw err;
    }
  }

  registrationReAuth(): void {
    try {
      if (this.android) {
        this.android.registrationReAuth();
      }
    } catch (err) {
      this.registrationFailed(err as Error);
      throw err;
    }
  }

  launchNativePlaidFlow(): void {
    try {
      if (
        this.android &&
        typeof this.android.launchNativePlaidFlow === 'function'
      ) {
        this.android.launchNativePlaidFlow();
      }
    } catch (err) {
      throw err;
    }
  }
}
